<template>
  <div class="MaterialsFilters">
    <div class="MaterialsFilters__side">
      <input
        v-model="filterText"
        type="text"
        placeholder="Search by name"
      />
      <SelectCustom
        :list="events"
        :name="$t('event')"
        label-by="name"
        v-model="filterEvent"
        :is-multiple="false"
        :show-count="false"
        display-selected
        round
      />
    </div>
    <div class="MaterialsFilters__types">
      <div class="MaterialsFilters__action">
        <slot/>
      </div>
      <div
        class="MaterialsFilters__type"
        :class="{'MaterialsFilters__type--active': type === 1}"
        @click="$emit('select', 1)"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.8125 2.8125H4.375C3.9606 2.8125 3.56317 2.97712 3.27015 3.27015C2.97712 3.56317 2.8125 3.9606 2.8125 4.375V7.8125C2.8125 8.2269 2.97712 8.62433 3.27015 8.91735C3.56317 9.21038 3.9606 9.375 4.375 9.375H7.8125C8.2269 9.375 8.62433 9.21038 8.91735 8.91735C9.21038 8.62433 9.375 8.2269 9.375 7.8125V4.375C9.375 3.9606 9.21038 3.56317 8.91735 3.27015C8.62433 2.97712 8.2269 2.8125 7.8125 2.8125ZM7.5 7.5H4.6875V4.6875H7.5V7.5ZM15.625 2.8125H12.1875C11.7731 2.8125 11.3757 2.97712 11.0826 3.27015C10.7896 3.56317 10.625 3.9606 10.625 4.375V7.8125C10.625 8.2269 10.7896 8.62433 11.0826 8.91735C11.3757 9.21038 11.7731 9.375 12.1875 9.375H15.625C16.0394 9.375 16.4368 9.21038 16.7299 8.91735C17.0229 8.62433 17.1875 8.2269 17.1875 7.8125V4.375C17.1875 3.9606 17.0229 3.56317 16.7299 3.27015C16.4368 2.97712 16.0394 2.8125 15.625 2.8125ZM15.3125 7.5H12.5V4.6875H15.3125V7.5ZM7.8125 10.625H4.375C3.9606 10.625 3.56317 10.7896 3.27015 11.0826C2.97712 11.3757 2.8125 11.7731 2.8125 12.1875V15.625C2.8125 16.0394 2.97712 16.4368 3.27015 16.7299C3.56317 17.0229 3.9606 17.1875 4.375 17.1875H7.8125C8.2269 17.1875 8.62433 17.0229 8.91735 16.7299C9.21038 16.4368 9.375 16.0394 9.375 15.625V12.1875C9.375 11.7731 9.21038 11.3757 8.91735 11.0826C8.62433 10.7896 8.2269 10.625 7.8125 10.625ZM7.5 15.3125H4.6875V12.5H7.5V15.3125ZM15.625 10.625H12.1875C11.7731 10.625 11.3757 10.7896 11.0826 11.0826C10.7896 11.3757 10.625 11.7731 10.625 12.1875V15.625C10.625 16.0394 10.7896 16.4368 11.0826 16.7299C11.3757 17.0229 11.7731 17.1875 12.1875 17.1875H15.625C16.0394 17.1875 16.4368 17.0229 16.7299 16.7299C17.0229 16.4368 17.1875 16.0394 17.1875 15.625V12.1875C17.1875 11.7731 17.0229 11.3757 16.7299 11.0826C16.4368 10.7896 16.0394 10.625 15.625 10.625ZM15.3125 15.3125H12.5V12.5H15.3125V15.3125Z" fill="#CCD7E6"/>
        </svg>
      </div>
      <div
        class="MaterialsFilters__type"
        :class="{'MaterialsFilters__type--active': type === 2}"
        @click="$emit('select', 2)"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.8125 10C17.8125 10.2486 17.7137 10.4871 17.5379 10.6629C17.3621 10.8387 17.1236 10.9375 16.875 10.9375H3.125C2.87636 10.9375 2.6379 10.8387 2.46209 10.6629C2.28627 10.4871 2.1875 10.2486 2.1875 10C2.1875 9.75136 2.28627 9.5129 2.46209 9.33709C2.6379 9.16127 2.87636 9.0625 3.125 9.0625H16.875C17.1236 9.0625 17.3621 9.16127 17.5379 9.33709C17.7137 9.5129 17.8125 9.75136 17.8125 10ZM3.125 5.9375H16.875C17.1236 5.9375 17.3621 5.83873 17.5379 5.66291C17.7137 5.4871 17.8125 5.24864 17.8125 5C17.8125 4.75136 17.7137 4.5129 17.5379 4.33709C17.3621 4.16127 17.1236 4.0625 16.875 4.0625H3.125C2.87636 4.0625 2.6379 4.16127 2.46209 4.33709C2.28627 4.5129 2.1875 4.75136 2.1875 5C2.1875 5.24864 2.28627 5.4871 2.46209 5.66291C2.6379 5.83873 2.87636 5.9375 3.125 5.9375ZM16.875 14.0625H3.125C2.87636 14.0625 2.6379 14.1613 2.46209 14.3371C2.28627 14.5129 2.1875 14.7514 2.1875 15C2.1875 15.2486 2.28627 15.4871 2.46209 15.6629C2.6379 15.8387 2.87636 15.9375 3.125 15.9375H16.875C17.1236 15.9375 17.3621 15.8387 17.5379 15.6629C17.7137 15.4871 17.8125 15.2486 17.8125 15C17.8125 14.7514 17.7137 14.5129 17.5379 14.3371C17.3621 14.1613 17.1236 14.0625 16.875 14.0625Z" fill="#CCD7E6"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import eventUtils from '@/mixins/eventUtils'
import SelectCustom from '@/components/form/SelectCustom.vue'

export default {
  name: 'MaterialsFilters',
  components: { SelectCustom },
  props: {
    type: Number,
    event: Number,
    text: Number,
  },
  mixins: [eventUtils],
  computed: {
    filterText: {
      get() {
        return this.text ?? null;
      },
      set(text) {
        this.$emit('setText', text);
      }
    },
    filterEvent: {
      get() {
        return this.event ? [this.event] : null;
      },
      set([eventId]) {
        this.$emit('setEvent', eventId);
      }
    },
    ...mapState('events', ['events', 'b2b', 'eventsFiltered', 'actualEvent', 'pending']),
  },
  methods: {
  }
}
</script>

<style lang="scss">
.MaterialsFilters {
  display: flex;
  align-items: center;
  justify-content: space-between;

  @include mobile {
    display: grid;
    grid-gap: 10px;
    align-items: unset;
    justify-content: unset;
  }

  &__types {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  &__action {
    margin-right: 20px;

    @include mobile {
      margin-right: 0;
      margin-bottom: 10px;
      width: 100%;
    }
  }

  &__side {
    display: flex;
    align-items: center;
    width: 100%;

    input {
      width: 285px;
      height: 40px;
      @include mobile {
        width: 100%;
      }
    }

    select, .select-custom {
      width: 120px;
      @include mobile {
        width: 100%;
      }
    }

    > * + * {
      margin-left: 10px;

      @include mobile {
        margin-left: 0;
      }
    }

    @include mobile {
      display: grid;
      grid-gap: 10px;
    }
  }

  &__type {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    cursor: pointer;

    @include mobile {
      display: none;
    }

    &:hover {
      svg {
        path {
          fill: #003882;
        }
      }
    }

    &--active {
      background: #F0F3F7;

      svg {
        path {
          fill: #003882;
        }
      }
    }
  }
}
</style>
